module.exports = __webpack_public_path__ + "static/img/czy33.4c56285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/czy33.jpg
// module id = Y2n5
// module chunks = 73